$(function() {
	$(".fancybox").fancybox();
});
